import { render, staticRenderFns } from "./farmingrecordlist.vue?vue&type=template&id=7476f5b5"
import script from "./farmingrecordlist.vue?vue&type=script&lang=js"
export * from "./farmingrecordlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports